'use client';

import Icon from '@/components/ui/AppIcon';

export default function CTASection() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center space-x-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
              <Icon name="PhoneIcon" size={20} className="text-primary" />
              <span className="text-primary text-sm font-medium">Get Started Today</span>
            </div>
            <h2 className="text-3xl lg:text-5xl font-display font-bold text-text-primary mb-6">
              Partner With Proximus
            </h2>
            <p className="text-lg text-text-secondary max-w-2xl mx-auto">
              Let's discuss how our corporate solutions can optimize your accommodation program and support your team's success.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-background rounded-lg p-6 text-center space-y-3 border border-border hover:border-primary/30 transition-all duration-300">
              <Icon name="PhoneIcon" size={32} className="text-primary mx-auto" />
              <h4 className="font-semibold text-text-primary">Call Our Sales Team</h4>
              <p className="text-text-secondary text-sm">+91 63669 97020</p>
              <p className="text-muted-foreground text-xs">Mon-Fri, 9 AM - 6 PM IST</p>
            </div>
            <div className="bg-background rounded-lg p-6 text-center space-y-3 border border-border hover:border-primary/30 transition-all duration-300">
              <Icon name="EnvelopeIcon" size={32} className="text-primary mx-auto" />
              <h4 className="font-semibold text-text-primary">Email Corporate Sales</h4>
              <p className="text-text-secondary text-sm">corporate@proximusindia.com</p>
              <p className="text-muted-foreground text-xs">Response within 4 hours</p>
            </div>
            <div className="bg-background rounded-lg p-6 text-center space-y-3 border border-border hover:border-primary/30 transition-all duration-300">
              <Icon name="CalendarIcon" size={32} className="text-primary mx-auto" />
              <h4 className="font-semibold text-text-primary">Schedule Consultation</h4>
              <p className="text-text-secondary text-sm">Book a meeting</p>
              <p className="text-muted-foreground text-xs">30-minute discovery call</p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-primary to-secondary rounded-2xl p-8 lg:p-12 text-center">
            <h3 className="text-2xl lg:text-3xl font-display font-bold text-white mb-4">
              Request a Custom Proposal
            </h3>
            <p className="text-white/90 mb-8 max-w-2xl mx-auto">
              Share your requirements and we'll create a tailored corporate package with pricing, service level agreements, and implementation timeline.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => {
                  window.location.href = `mailto:corporate@proximusindia.com?subject=Corporate%20Accommodation%20Proposal%20Request&body=Dear%20Proximus%20Corporate%20Team%2C%0A%0AWe%20are%20interested%20in%20your%20corporate%20accommodation%20solutions.%0A%0APlease%20find%20our%20requirements%20below.%0A%0ACompany%20Name%3A%0A%0AContact%20Person%3A%0A%0ADesignation%3A%0A%0AEmail%3A%0A%0APhone%3A%0A%0ACompany%20Address%3A%0A%0ANumber%20of%20Rooms%20Required%3A%0A%0AExpected%20Room%20Nights%20Per%20Month%3A%0A%0AExpected%20Check%20In%20Date%3A%0A%0AExpected%20Duration%20of%20Stay%3A%0A%0APreferred%20Room%20Category%3A%0A%0ASpecial%20Requirements%3A%0A%0APlease%20share%20your%20best%20corporate%20rates%20and%20proposal.%0A%0AThank%20you.%0A%0AKind%20Regards%2C`;
                }}
                className="px-8 py-4 bg-accent hover:bg-accent/90 text-white font-semibold rounded-lg shadow-elevated transition-all duration-300 hover:scale-105 flex items-center justify-center space-x-2">
                <Icon name="DocumentTextIcon" size={20} />
                <span>Request Proposal</span>
              </button>
              <a
                href="/apartment-categories"
                className="px-8 py-4 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-semibold rounded-lg border-2 border-white/30 transition-all duration-300 flex items-center justify-center space-x-2">

                <Icon name="HomeIcon" size={20} />
                <span>View Properties</span>
              </a>
            </div>
          </div>

          <div className="mt-12 bg-background rounded-xl p-8 border border-border">
            <h3 className="text-xl font-display font-bold text-text-primary mb-6 text-center">
              Partnership Process
            </h3>
            <div className="grid md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-xl font-bold text-primary">1</span>
                </div>
                <h4 className="font-semibold text-text-primary mb-2">Initial Consultation</h4>
                <p className="text-sm text-text-secondary">Discuss your needs and requirements</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-xl font-bold text-primary">2</span>
                </div>
                <h4 className="font-semibold text-text-primary mb-2">Custom Proposal</h4>
                <p className="text-sm text-text-secondary">Receive tailored package and pricing</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-xl font-bold text-primary">3</span>
                </div>
                <h4 className="font-semibold text-text-primary mb-2">Agreement & Setup</h4>
                <p className="text-sm text-text-secondary">Sign SLA and configure portal access</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-xl font-bold text-primary">4</span>
                </div>
                <h4 className="font-semibold text-text-primary mb-2">Launch & Support</h4>
                <p className="text-sm text-text-secondary">Onboard team with dedicated support</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}